<template>
  <sa-page-layout :btnSaveVisible="btnSaveVisible" :btnAnnullaVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
    <template slot="table-body">
      <gestione-attivita-attivita-edit-component @updateJsonData="onUpdateJsonData"></gestione-attivita-attivita-edit-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GestioneAttivitaAttivitaEditComponent from "../components/GestioneAttivitaAttivitaEditComponent.vue";
export default {
  components: { GestioneAttivitaAttivitaEditComponent, SaPageLayout },
  data() {
    return {
      btnSaveVisible: true,
      showModalLoading: false,
      linkback: "/gestioneattivita/attivita",
      pathResource: "/gestioneattivitaattivita",
      jsonData: null,
    };
  },
  methods: {
    onUpdateJsonData(jsonData) {
      this.jsonData = jsonData;
    },
  },
};
</script>

<style></style>
